import { useEffect, useRef, useState } from 'react'
import WelcomePage from './components/WelcomePage'
import SignupDialog from './components/auth/SignupDialog'
import LoginDialog from './components/auth/LoginDialog'
import { AuthAPI } from './services/auth'

function goToGame(): void {
  window.location.href = '/game.html'
}

export default function WelcomeApp() {
  const [signupOpen, setSignupOpen] = useState(false)
  const [loginOpen, setLoginOpen] = useState(false)
  const authCheckedRef = useRef(false)

  useEffect(() => {
    if (authCheckedRef.current) return
    authCheckedRef.current = true

    AuthAPI.getUserInfo()
      .then(() => goToGame())
      .catch(() => {})
  }, [])

  return (
    <>
      <WelcomePage
        onStartSignup={() => setSignupOpen(true)}
        onLogin={() => setLoginOpen(true)}
      />
      <SignupDialog
        open={signupOpen}
        onClose={() => setSignupOpen(false)}
        onSuccess={goToGame}
      />
      <LoginDialog
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onSuccess={goToGame}
      />
    </>
  )
}
